import React, { Component, Ref } from "react";
import { _ReactPixi, withPixiApp, Container } from "@inlet/react-pixi";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import UIManager from "../../core/components/ui/UiBuilder";
import * as PIXI from 'pixi.js';
import { actions as layoutssActions } from "../../core/reducers/layoutsStateReducer";
import { isMobile } from "react-device-detect";
import { TIMER } from "../../core/utills";
import { actions as randomWildActions } from "../../gamereducer/randomWildReducer";
import withSkullContainerConfiguration from "./configuration/withskullcontainerconfiguration";
import { Tween } from "../../core/components/effect/tween";
import easing from "../../core/components/effect/easing";
import { actions as symbolActions } from "../../core/reducers/symbolStateReducer";
import { actions as reelgridAction } from '../../core/reducers/reelgridStateReducer';
import { actions as soundActions } from "../../core/reducers/soundReducer";
import { BaseAnimatedparticle } from "../../core/components/effect/baseanimatedparticle";
import { PathTween } from "../../core/components/effect/pathtween";
import { configGame } from "../../data/config"

interface IStore {
    [x: string]: any;
}

interface IProps {
    [x: string]: any;


}

interface IStateToProps {
    [x: string]: any;

}

interface IDispatchToProps {

}

interface IState {
    [x: string]: any;
}

class SkullContainer extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected skullContainer: any;
    protected ui_mode: string;
    protected displayUI: any;
    protected scatterCount: number = 0;
    protected xAxis: number = configGame.REEL_CONTAINER_X;
    protected yAxis: number = configGame.REEL_CONTAINER_Y;

    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.state = {
            uiElements: [],
            lang: "en"
        }
        this.skullContainer = React.createRef();
        if (isMobile) {
            this.ui_mode = "mobile";
        } else {
            this.ui_mode = "desktop";
        }

        this.displayUI = this.props.data.COMPONENTS.filter(this.checkUiMode.bind(this));

    }

    checkUiMode(uimodeobj: any) {

        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both";
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }


    bindUI() {
        this.layoutChange(this.props.layoutMode);
    }


    initializeObjectInVariable() {

    }

    handleRotation(isFeatureShown: any) {

    }

    showHighlightedSkull(nextProps: any) {
        if (nextProps.skullArr[nextProps.stoppedReel] === 1) {
            this.scatterCount++
            if (this.scatterCount < 6) {
                let skullName = `bg_skull_selected_${this.scatterCount}`
                let skullSelected = UIManager.getRef(skullName)
                skullSelected.visible = true;
            }

        }
        if (nextProps.stoppedReel === 5) {

            //this.addPathTween();
        }
    }
    showHighlightedSkullDuringCascade(nextProps: any) {
        
        if (nextProps.skullArr[this.scatterCount] === 1) {
            this.scatterCount++
            if (this.scatterCount < 6) {
                let skullName = `bg_skull_selected_${this.scatterCount}`
                let skullSelected = UIManager.getRef(skullName)
                skullSelected.visible = true;
            }

        }
    }



    componentDidMount() {
        this.initializeObjectInVariable();
        this.bindUI();
    }
    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (nextProps.skullArr !== this.props.skullArr
            || nextProps.stoppedReel !== this.props.stoppedReel
            || nextProps.spinStart !== this.props.spinStart
            || nextProps.scatterPositions !== this.props.scatterPositions
            || nextProps.layoutMode !== this.props.layoutMode
            || nextProps.cascadeSkull !== this.props.cascadeSkull

        ) {
            if (nextProps.layoutMode !== this.props.layoutMode) {

                this.layoutChange(nextProps.layoutMode);

                return false;
            }
            if (nextProps.stoppedReel > -1 && nextProps.stoppedReel !== this.props.stoppedReel) {
                this.showHighlightedSkull(nextProps);
                return false;
            }
            if (nextProps.cascadeSkull > 0 && nextProps.cascadeSkull !== this.props.cascadeSkull) {
                this.showHighlightedSkullDuringCascade(nextProps);
                return false;
            }

            if (nextProps.spinStart !== this.props.spinStart) {
                this.scatterCount = 0;
                return true;
            }
            return false;
        }
        return true;
    }

    layoutChange(currentLayout: string) {
        if (isMobile && window.innerWidth > window.innerHeight) {
            UIManager.getRef("SkullMainContainer_mobile").scale.set(1);
        }
        else if (isMobile && window.innerWidth < window.innerHeight) {
            UIManager.getRef("SkullMainContainer_mobile").scale.set(1.2);
        }

        this.displayUI.map((data: any,) => {
            if (data.layout === true) {
                this.props.setApplicationLayoutObject(data.name);

            }
        })
    }

    addPathTween() {
        let positions: any[] = this.props.scatterPositions

        positions.forEach((singlePos: any, index: any) => {

            let skullAnimObj = UIManager.getRef("skull_meter_fx_" + index)
            skullAnimObj.visible = true;
            skullAnimObj.scale.set(0.8);
            skullAnimObj.play()
            let reel = singlePos[0]
            let row = singlePos[1]

            let endPositionArr = [[775, 117], [854, 110], [941, 105], [1027, 110], [1107, 117]]

            let startX = this.xAxis + reel * configGame.SYMBOL_WIDTH + configGame.SYMBOL_WIDTH / 2
            let startY = this.yAxis + row * configGame.SYMBOL_HEIGHT + configGame.SYMBOL_HEIGHT
            skullAnimObj.x = startX
            skullAnimObj.y = startY

            let endX = endPositionArr[index][0]
            let endY = endPositionArr[index][1]

            let mid_x, mid_y;

            if (startX > endX) {
                mid_x = endX + (startX - endX) / 2;
                mid_y = endY + (startY - endY) / 2;
            } else {
                mid_x = startX + (endX - startX) / 2;
                mid_y = endY + (startY - endY) / 2;
            }

            this.playGlowAnimations(index, startX, startY, 0.8)
            let newTween = new PathTween(
                skullAnimObj,
                [
                    { x: startX, y: startY },

                    { x: mid_x, y: mid_y },


                    { x: endX, y: endY },
                ],
                1,
                "bezier",
                "easeLinear", null, false, false, (e: any) => {

                }, () => {
                    skullAnimObj.rotation = 0;
                    this.playGlowAnimations(index, endX, endY, 0.3)
                    skullAnimObj.visible = false;
                }
            );
            newTween.start();

            this.addTilt(skullAnimObj, 0.45)

            let timer = TIMER.TimerManager.createTimer(800);
            timer.on('end', () => {
                this.addScaleTween(skullAnimObj)

            });
            timer.start();

        });


    }

    addScaleTween(obj: any) {
        if (obj) {
            let startScale = 0.8
            new Tween(
                [obj.scale],
                {
                    'x': { start: startScale, end: 0.5 },
                    'y': { start: startScale, end: 0.5 }
                },
                .2,
                easing.easeLinear,
                false, null, null, null, null, false, null, () => {

                }
            );
        }
    }

    addTilt(obj: any, angle: any) {
        new Tween(
            [obj],
            {
                'rotation': { start: obj.rotation, end: angle }
            },
            0.3,
            easing.easeLinear,
            false, null, null, null, null, false, null, () => {
                new Tween(
                    [obj],
                    {
                        'rotation': { start: obj.rotation, end: -angle }
                    },
                    0.6,
                    easing.easeLinear,
                    false, null, null, null, null, false, null, () => {
                        new Tween(
                            [obj],
                            {
                                'rotation': { start: obj.rotation, end: 0 }
                            },
                            0.1,
                            easing.easeLinear,
                            false, null, null, null, null, false, null, () => {

                            }
                        );
                    }
                );
            }
        );
    }

    playGlowAnimations(count: any, x_pos: any, y_pos: any, scaleVal: any) {
        let skullGlow = UIManager.getRef("skullGlowOnReel_" + count)
        skullGlow.visible = true;
        skullGlow.scale.set(scaleVal);
        skullGlow.position.set(x_pos, y_pos - 40);
        let spineName = "fx_glow_blue";
        if (skullGlow) {
            skullGlow.children[0].state.setAnimation(0, spineName, false);
            skullGlow.children[0].state.onComplete = () => {
                //skullGlow.visible = false;
                //skullGlow.position.set(0);
            }
        }

    }


    componentDidUpdate() {
        this.layoutChange(this.props.layoutMode);
    }
    render() {

        return (
            <UIManager id={"SkullContainer"} name={"SkullContainer"} type={"Container"}
                ref={i => this.skullContainer = i} configGame={this.props.configGame}
                app={this.app} >
                {
                    this.displayUI && this.displayUI.map((i: any) =>
                        <UIManager key={`UIManager-${Math.random()}`} langObj={this.props.langObj} type={i.type}
                            id={i.id} {...i} app={this.app} configGame={this.props.configGame}
                            scope={this} />
                    )
                }
            </UIManager>

        )
    }

}

export default withPixiApp(connect(
    (state: Pick<IStore, 'applicationState' | 'skullState' | 'gridsState'>): IStateToProps =>
    ({
        skullArr: state.skullState.skullArr,
        scatterPositions: state.skullState.scatterPositions,
        stoppedReel: state.gridsState.stoppedReel,
        spinStart: state.gridsState.spinStart,
        layoutMode: state.applicationState.layoutMode,
        cascadeSkull: state.skullState.cascadeSkull,
    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        setApplicationLayoutObject: (layoutobjectlist: any): any => dispatch(layoutssActions.setApplicationLayoutObject(layoutobjectlist)),
    }))(withSkullContainerConfiguration(SkullContainer)));